// The footer's theme links (layouts/_dark_mode_controls): each has data-dark-mode-preference (auto, light or dark).
// Choosing one remembers it in a cookie, which the server reads to render <html data-color-mode> on later pages (so
// there's no flash of the wrong theme), and switches the theme on this page straight away.
const PREFERENCES = ['auto', 'light', 'dark']

function setPermanentCookie(key, value) {
  // Browsers cap this at about 400 days from the last time it's set
  const farFutureDate = new Date('3000-01-01')
  document.cookie = key + ' = ' + value + '; expires = ' + farFutureDate.toUTCString() + '; path = /;'
}

function setDarkModePreference(preference) {
  if (!PREFERENCES.includes(preference)) return

  setPermanentCookie('dark_mode_preference', preference)
  document.documentElement.dataset.colorMode = preference

  document.querySelectorAll('.dark-mode-toggle').forEach((link) => {
    const chosen = link.getAttribute('data-dark-mode-preference') === preference
    link.classList.toggle('bold', chosen)
    link.setAttribute('aria-pressed', chosen ? 'true' : 'false')
  })
}

document.addEventListener('click', (e) => {
  const link = e.target.closest && e.target.closest('.dark-mode-toggle[data-dark-mode-preference]')
  if (!link) return
  e.preventDefault()
  setDarkModePreference(link.getAttribute('data-dark-mode-preference'))
})
